
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre-mi",
      function () {
        return require("private-next-pages/sobre-mi.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sobre-mi"])
      });
    }
  